import { useGetTagsQuery } from 'src/legacy/components/Admin/Tags/tagQueries.generated'

export default function useLoadParticipantTags() {
  const { data, loading } = useGetTagsQuery()
  return loading || !data ? [] : data.patientTags
}
